<template>
  <div>
    <div v-if="fileListShow">
      <el-dropdown placement="bottom">
        <span class="el-dropdown-link chaochu" style="font-size:13px;">
          {{fileList.name}}
        </span>
        <el-dropdown-menu slot="dropdown">
          <div class="dropdown_list">
            <el-dropdown-item class="dropdown_a">
              <a class="updA_text" 
                href="javascript:void(0);" 
                @click="downloadFile(fileList.path, fileList.name)" 
                :download="fileList.name">
              下载
            </a>
            </el-dropdown-item>
            <el-dropdown-item @click.native="handleEdit(fileList.path)">预览</el-dropdown-item>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <template v-else>
      <div v-for="(item,index) in fileList" :key="index" style="height:24px;">
        <el-dropdown placement="bottom">
          <span class="el-dropdown-link chaochu" style="font-size:13px;">
            {{item.name}}
          </span>
          <el-dropdown-menu slot="dropdown">
            <div class="dropdown_list">
              <el-dropdown-item class="dropdown_a">
                <a class="updA_text" 
                  href="javascript:void(0);" 
                  @click="downloadFile(item.path, item.name)" 
                  :download="item.name">
                下载
              </a>
              </el-dropdown-item>
              <el-dropdown-item @click.native="handleEdit(item.path)">预览</el-dropdown-item>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </template>
    <el-dialog title="预览" :visible.sync="viewVisible" width="50%" :modal="modalShow">
      <div class="pdf" v-if="fileType === 'pdf'">
        <el-button-group>
          <el-button type="primary" icon="el-icon-arrow-left" size="mini" @click="prePage">上一页</el-button>
          <el-button type="primary" size="mini" @click="nextPage">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
        </el-button-group>
        <div style="marginTop: 10px; color: #409EFF">{{ pageNum }} / {{ pageTotalNum }}</div>
        <pdf 
          :page="pageNum"
          :src="pdfsrc"
          @progress="loadedRatio = $event"
          @num-pages="pageTotalNum=$event" >
        </pdf>
      </div>
      <div v-else>
        <img style="width:100%;height:100%;" :src="pdfsrc" alt="">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pdf from "vue-pdf";
export default {
  components: {
    pdf,
  },
  props:['fileList','modalShow','fileListShow'],
  data() {
    return {
      viewVisible: false, // 弹框隐藏
      fileType: "pdf", // 文件类型
      pdfsrc: "", // 文件地址
      pageNum: 1,
      pageTotalNum: 1,
    };
  },
  watch:{
    viewVisible(row){
      if(row){
        this.pageNum = 1;
      }
    }
  },
  methods: {
    handleEdit(path){
      if (/\.(pdf|PDF)$/.test(path)) {
        this.viewVisible = true
        this.pdfsrc = path
        this.fileType = "pdf"
      }else if(/\.(png|PNG|jpg|JPG|jpeg|JPEG|gif|GIF)$/.test(path)){
        this.fileType = "png"
        this.viewVisible = true
        this.pdfsrc = path
      } else {
        // 不是pdf格式
        path = encodeURIComponent(path);
        window.open(
          "https://view.officeapps.live.com/op/view.aspx?src=" + path
        );
        return false;
      }
    },
    // 上一页
    prePage() {
      let page = this.pageNum
      page = page > 1 ? page - 1 : this.pageTotalNum
      this.pageNum = page
    },

    // 下一页
    nextPage() {
      let page = this.pageNum
      page = page < this.pageTotalNum ? page + 1 : 1
      this.pageNum = page
    },
  },
    
};
</script>
<style lang="scss" scoped>
.chaochu{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.v-modal{
  z-index: 0 !important;
}
.dropdown_list{
  display: flex;
}
.updA_text{
  font-weight: 400;
  font-size: 14px;
}
.dropdown_a:hover .updA_text{
  color: #409eff;
}
</style>
